import React, { useEffect, useState } from "react";
import { Card, Col, Form, Input, Row, Select, Upload } from "antd";
import {  CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { dispatch, useSelector } from "../../../redux/store";
import { openNotification } from "../../../global/item/Notification/Notification";
import Loading from "../../../global/item/Loading/loading";
import ButtonBottom from "../../../global/item/ButtonComponent/ButtonBottom";
import { getGroup } from "../../../redux/action/groups";
import { Group } from "../../../@type/group";
import { postFlower } from "../../../redux/action/flower";

const { Option } = Select;
const { Dragger } = Upload;

function ProductCreateScreen() {
  const { t } = useTranslation();
  const [uploadedImages, setUploadedImages] = useState<string[]>([]);
  const [form] = Form.useForm();
  const { groupList } = useSelector((state) => state.group);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // HANDLE UPLOAD FILE (CHỈ CHẠY 1 LẦN / FILE)
  const handleFileUpload = (file: File) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      if (e.target?.result) {
        setUploadedImages((prev) => [...prev, e.target!.result!.toString()]);
      }
    };
    reader.readAsDataURL(file);
  };

  const handleRemoveImage = (index: number) => {
    setUploadedImages((prev) => prev.filter((_, i) => i !== index));
  };
const handleSubmit = async () => {
  setLoading(true);
  try {
    const values = await form.validateFields();

    if (uploadedImages.length === 0) {
      openNotification({
        type: "error",
        message: "Lỗi",
        description: "Vui lòng chọn ít nhất 1 ảnh!",
      });
      setLoading(false);
      return;
    }
    if (values.category === undefined) {
      openNotification({
        type: "error",
        message: "Lỗi",
        description: "Vui lòng chọn danh mục!",
      });
      setLoading(false);
      return;
    }

    // Upload ảnh lên Cloudinary
    const uploadedImgUrls: string[] = [];

    for (const image of uploadedImages) {
      const file = await fetch(image).then((res) => res.blob());
      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", "hoatuoi");

      const res = await fetch(
        "https://api.cloudinary.com/v1_1/dcxwarx50/image/upload",
        { method: "POST", body: formData }
      );

      const data = await res.json();
      uploadedImgUrls.push(data.secure_url);
    }

    await dispatch(
      postFlower({
        name: values.name,
        lifespan: values.lifespan,
        origin: values.origin,
        feature: values.feature,
        meaning: values.meaning,
        description: values.description,
        price: values.price,
        groupId: values.category,

        images: uploadedImgUrls.map((url) => ({
          imageType: "Anh1",   // hoặc thay bằng type bạn mong muốn
          imageUrl: url,
        })),
      })
    );

    openNotification({
      type: "success",
      message: t("update"),
      description: t("messUpdate"),
    });

    navigate("/product/data");
  } catch (err) {
    console.error(err);
    openNotification({
      type: "error",
      message: "Lỗi",
      description: "Dữ liệu cập nhật thất bại!",
    });
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    dispatch(getGroup());
  }, []);

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <Form
          form={form}
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          autoComplete="off"
          requiredMark={false}
        >
          <Card className="layoutItem">
            <h3 style={{ color: `var(--primary-color)`, marginBottom: 8 }}>
              {t("basicInformation")}
            </h3>

            <Row gutter={[20, 0]}>
              <Col xl={12}>
                <Form.Item
                  label={"Tên sản phẩm"}
                  name="name"
                  rules={[{ required: true, message: "Không được để trống" }]}
                >
                  <Input placeholder="Nhập tên sản phẩm" />
                </Form.Item>
              </Col>

              <Col xl={12}>
                <Form.Item
                  label={"Danh mục"}
                  name="category"
                  rules={[{ required: true, message: "Không được để trống" }]}
                >
                  <Select placeholder="Chọn danh mục" style={{height:46}}>
                    {groupList?.map((group: Group) => (
                      <Option key={group.groupId} value={group.groupId}>
                        {group.groupName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col xl={12}>
                <Form.Item label="Vòng đời" name="lifespan" rules={[{ required: true }]}>
                  <Input placeholder="Nhập vòng đời" />
                </Form.Item>
              </Col>

              <Col xl={12}>
                <Form.Item label="Giá" name="price" rules={[{ required: true }]}>
                  <Input placeholder="Nhập giá" />
                </Form.Item>
              </Col>

              <Col xl={12}>
                <Form.Item label="Nguồn gốc" name="origin" rules={[{ required: true }]}>
                  <Input placeholder="Nhập nguồn gốc" />
                </Form.Item>
              </Col>

              <Col xl={12}>
                <Form.Item label="Đặc điểm" name="feature" rules={[{ required: true }]}>
                  <Input.TextArea placeholder="Nhập đặc điểm" />
                </Form.Item>
              </Col>

              <Col xl={12}>
                <Form.Item label="Ý nghĩa" name="meaning" rules={[{ required: true }]}>
                  <Input.TextArea placeholder="Nhập ý nghĩa" />
                </Form.Item>
              </Col>

              <Col xl={12}>
                <Form.Item label="Mô tả" name="description" rules={[{ required: true }]}>
                  <Input.TextArea placeholder="Nhập mô tả" />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          {/* UPLOAD IMAGE */}
          <Card className="layoutItem">
            <h3 style={{ color: `var(--primary-color)`,paddingBottom:10 }}>{t("imageInfo")}</h3>

            {uploadedImages.length > 0 && (
              <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
                {uploadedImages.map((image, idx) => (
                  <Col xl={6} lg={8} md={12} xs={24} key={idx}>
                    <div style={{ position: "relative" }}>
                      <CloseOutlined
                        style={{
                          position: "absolute",
                          top: 10,
                          right: 10,
                          padding: 6,
                          borderRadius: "50%",
                          background: "#fff",
                          cursor: "pointer",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                        }}
                        onClick={() => handleRemoveImage(idx)}
                      />
                      <img
                        src={image}
                        alt="Uploaded"
                        style={{
                          width: "100%",
                          height: 200,
                          objectFit: "cover",
                          borderRadius: 10,
                        }}
                      />
                    </div>
                  </Col>
                ))}
              </Row>
            )}

            <Form.Item
              name="images"
              rules={[
                {
                  validator: () =>
                    uploadedImages.length === 0
                      ? Promise.reject("Vui lòng tải lên ít nhất 1 ảnh")
                      : Promise.resolve(),
                },
              ]}
            >
              <Dragger
                multiple={false}
                showUploadList={false}
                beforeUpload={(file) => {
                  handleFileUpload(file);
                  return false; // CHẶN UPLOAD TỰ ĐỘNG — KHÔNG BỊ LẶP
                }}
              >
                <p className="ant-upload-drag-icon">
        <PlusOutlined style={{ fontSize: 40, color: "#4096ff" }} />
      </p>
      <p className="ant-upload-text" style={{ fontSize: 16, fontWeight: 500 }}>
        {uploadedImages.length > 0 ? "Thêm ảnh khác" : "Tải ảnh lên"}
      </p>
      <p className="ant-upload-hint" style={{ fontSize: 13 }}>
        Kéo thả hoặc bấm để chọn ảnh • JPG • PNG • WebP
      </p>
              </Dragger>
            </Form.Item>
          </Card>

          <ButtonBottom
            onContinueClick={handleSubmit}
            btnCancel={t("cancel")}
            btnContinue={t("continue")}
          />
        </Form>
      )}
    </div>
  );
}

export default ProductCreateScreen;
